import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { BrowserRouter, Switch } from 'react-router-dom';
import Sidebar from './component/sidebar/';

import DashboardPage from './container/dashboardReportsPage';
import MissingPage from './container/404Page';
import SignUpStatsPage from './container/signUpStatisticsPage';
import PackageStatsPage from './container/packageStatsPage';
import ShipmentStatsPage from './container/shipmentStatsPage';
import RevenueStatsPage from './container/revenueStatsPage';
import CountryStatsPage from './container/countryStatsPage';
import SourceStatsPage from './container/sourceStatsPage';
import CannedReportsPage from './container/cannedReportsPage';
import AdHocReportsPage from './container/adHocReportsPage';
import WarehouseReportsPage from './container/warehouseStatsPage';

class Router extends Component {
    render() {
        return (
            <BrowserRouter>
                <div>
                    <Sidebar></Sidebar>
                    <Switch>
                        <Route exact path="/" component={SignUpStatsPage}/>
                        <Route exact path="/reporting" component={SignUpStatsPage}/>
                        <Route exact path="/reporting/dashboard" component={DashboardPage} />
                        <Route path="/reporting/dashboard/:number" component={DashboardPage} />
                        <Route path="/reporting/dashboard" component={DashboardPage} />
                        <Route path="/reporting/signupstats" component={SignUpStatsPage} />
                        <Route path="/reporting/packagestats" component={PackageStatsPage} />
                        <Route path="/reporting/shipmentstats" component={ShipmentStatsPage} />
                        <Route path="/reporting/revenuestats" component={RevenueStatsPage} />
                        <Route path="/reporting/countrystats" component={CountryStatsPage} />
                        <Route path="/reporting/sourcestats" component={SourceStatsPage} />
                        <Route path="/reporting/cannedreports" component={CannedReportsPage} />
                        <Route path="/reporting/adhocreports" component={AdHocReportsPage} />
                        <Route path="/reporting/warehousereports" component={WarehouseReportsPage} />
                        <Route component={MissingPage}/>
                    </Switch>
                </div>
            </BrowserRouter>
        );
    }
}

export default Router;